module.exports = __webpack_public_path__ + "img/finmollBig.a3ab96f0.svg";